// extracted by mini-css-extract-plugin
var _1 = "IconList-modulecontainer__mR7qJ Container-modulecontent__hwVr6";
var _2 = "IconList-modulesizes__lw0Cz";
export { _1 as "container", _2 as "sizes" }
